module.exports = __webpack_public_path__ + "static/media/join-our-community-background.de308658.svg";